export default __webpack_public_path__ + "static/media/estante.d5237f47.svg";